

module.exports = __webpack_require__.stylable.create(
    "Header1293373767",
    {"classes":{"root":"Header1293373767__root","title":"Header1293373767__title","media":"Header1293373767__media","image":"Header1293373767__image","BookButton":""},"vars":{},"stVars":{},"keyframes":{}},
    "",
    9,
    "Header1293373767",
    null
);
